import axios from "axios";
import { showSuccessNotification, showErrorNotification } from "actions/action-complete-notificator";

export const ACTION_SAVE_CLIENT_PENDING = 'ACTION_SAVE_CLIENT_PENDING';
export const ACTION_SAVE_CLIENT_SUCCESS = 'ACTION_SAVE_CLIENT_SUCCESS';
export const ACTION_SAVE_CLIENT_ERROR = 'ACTION_SAVE_CLIENT_ERROR';

function saveClientPending() {
    return {
        type: ACTION_SAVE_CLIENT_PENDING
    }
}

function saveClientSuccess() {
    showSuccessNotification("Zapisano zmiany");
    return {
        type: ACTION_SAVE_CLIENT_SUCCESS
    }
}

function saveClientError(error) {
    showErrorNotification(error.response);
    return {
        type: ACTION_SAVE_CLIENT_ERROR,
        error: error
    }
}

function saveClientAction(data) {
    axios.defaults.baseURL = window.location.origin;
    var url = '/api/Client/';
    return dispatch => {
        dispatch(saveClientPending());
        axios.put(url, data, { withCredentials: true })
            .then(res => res.data)
            .then(res => {
                dispatch(saveClientSuccess());
                return res;
            })
            .catch(error => {
                dispatch(saveClientError(error));
            })
    }
}

export default saveClientAction;
